import { render } from "./EmailLogs.vue?vue&type=template&id=548f5336"
import script from "./EmailLogs.vue?vue&type=script&lang=js"
export * from "./EmailLogs.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__